import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../service/auth/auth.service';
import { PermissionService } from '../service/permission/permission.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private permService: PermissionService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      const url = state.url;
      const isClubHome = url.startsWith('/club');
      const isFedHome = url.startsWith('/federation');

      const isSharedAuthenticatedArea =
        url.startsWith('/Joueurs') ||
        url.startsWith('/Dirigeants') ||
        url.startsWith('/Staff') ||
        url.startsWith('/Arbitres') ||
        url.startsWith('/Formulaires');

      const isFederationOnlyAlias = url.startsWith('/Clubs');

      if (isSharedAuthenticatedArea) {
        return true;
      }

      if (isClubHome && this.authService.isClub()) {
        return true;
      }
      if ((isFedHome || isFederationOnlyAlias) && this.authService.isFederation()) {
        return true;
      }

      // If already logged in but on wrong route, redirect to their home. Not every
      // club-scoped role has clubs:read (e.g. CLUB_REFE only has arbitres:read) — land on
      // the first club-area route this account's own permissions actually grant.
      if (this.authService.isClub()) {
        this.router.navigate([this.permService.getClubLandingRoute()]);
        return false;
      }
      if (this.authService.isFederation()) {
        this.router.navigate(['/federation']);
        return false;
      }
    }

    // Not authenticated — redirect to role selector
    this.router.navigate(['/accueil']);
    return false;
  }
}
